import { TutorialStep, PageTutorialConfig } from '../types';

// Header steps for client context
export const clientHeaderSteps: TutorialStep[] = [
  {
    target: '[data-onboarding="sidebar-trigger"]',
    title: "Menu latéral",
    message: "Accédez à vos demandes, votre profil et toutes les fonctionnalités client",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="home-button"]',
    title: "Tableau de bord",
    message: "Retournez à votre tableau de bord client pour voir vos missions et statistiques",
    position: "bottom"
  },
  {
    target: '[data-onboarding="back-button"]',
    title: "Retour",
    message: "Revenez à la page précédente",
    position: "bottom"
  },
  {
    target: '[data-onboarding="role-badge"]',
    title: "Votre rôle",
    message: "Ce badge indique que vous êtes connecté en tant que Client",
    position: "bottom"
  },
  {
    target: '[data-onboarding="language-selector"]',
    title: "Langue",
    message: "Changez la langue de l'interface selon vos préférences",
    position: "bottom-left"
  },
  {
    target: '[data-onboarding="logout-button"]',
    title: "Déconnexion",
    message: "Déconnectez-vous de votre espace client",
    position: "bottom-left"
  },
  {
    target: '[data-onboarding="help-button"]',
    title: "Aide",
    message: "Cliquez ici à tout moment pour revoir ce tutoriel",
    position: "bottom-left"
  },
  // Sidebar steps client
  {
    target: '[data-onboarding="sidebar-client-dashboard"]',
    title: "Mon Dashboard",
    message: "Accédez à votre tableau de bord pour voir vos statistiques et activités",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-client-demandes"]',
    title: "Mes Demandes",
    message: "Créez une nouvelle demande ou consultez l'historique de vos missions",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-client-infos"]',
    title: "Mes Informations",
    message: "Gérez vos informations personnelles et paramètres de compte",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-client-carte"]',
    title: "Carte",
    message: "Visualisez les prestataires disponibles sur la carte",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-client-support"]',
    title: "Support",
    message: "Contactez notre équipe support en cas de besoin",
    position: "bottom-right"
  }
];

// Page-specific tutorials for client pages
export const clientPageConfigs: PageTutorialConfig[] = [
  {
    routePattern: "/dashboard-client",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="client-help-navigation"]',
        title: "Aide à la navigation",
        message: "Ce bloc vous rappelle comment accéder au menu latéral pour naviguer dans votre espace client.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-missions-card"]',
        title: "Synthèse de vos missions",
        message: "Visualisez en un coup d'œil le nombre et le statut de toutes vos missions (brouillon, en attente, en cours, terminée...).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-profile-card"]',
        title: "Complétion de votre profil",
        message: "Ce bloc indique le pourcentage de complétion de votre profil. Un profil complet permet un meilleur service.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-profile-info-btn"]',
        title: "Détail de la complétion",
        message: "Cliquez sur ce bouton pour voir en détail les informations manquantes à compléter dans votre profil.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="client-profile-btn"]',
        title: "Accéder à mon profil",
        message: "Cliquez ici pour compléter ou modifier vos informations personnelles.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-support-card"]',
        title: "Tickets support",
        message: "Consultez vos tickets de support et leur état. Vous pouvez contacter notre équipe en cas de question ou problème.",
        position: "bottom-left"
      }
    ]
  },
  {
    routePattern: "/client/dashboard",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="client-help-navigation"]',
        title: "Aide à la navigation",
        message: "Ce bloc vous rappelle comment accéder au menu latéral.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/client/mes-infos",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="client-infos-identity-card"]',
        title: "Bloc Identité",
        message: "Renseignez votre nom, prénom et adresse email. Ces informations sont essentielles pour vous identifier.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-nom"]',
        title: "Votre nom",
        message: "Saisissez votre nom de famille tel qu'il apparaît sur votre pièce d'identité.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-prenom"]',
        title: "Votre prénom",
        message: "Saisissez votre prénom tel qu'il apparaît sur votre pièce d'identité.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-email"]',
        title: "Adresse email",
        message: "Renseignez une adresse email valide pour recevoir les notifications et confirmations.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-contact-card"]',
        title: "Bloc Contact",
        message: "Vos coordonnées téléphoniques pour être contacté par les prestataires.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-phone"]',
        title: "Téléphone principal",
        message: "Ce numéro est votre identifiant de connexion. Contactez le support pour le modifier.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-whatsapp"]',
        title: "WhatsApp",
        message: "Ajoutez un numéro WhatsApp pour être contacté plus facilement par les prestataires.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-address-card"]',
        title: "Bloc Adresse",
        message: "Votre adresse permet de trouver des prestataires proches de chez vous.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-address-input"]',
        title: "Adresse complète",
        message: "Commencez à taper votre adresse, des suggestions apparaîtront automatiquement grâce à Google Maps.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-documents-card"]',
        title: "Pièce d'identité",
        message: "Téléchargez le recto et le verso de votre pièce d'identité pour valider votre profil.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-doc-recto"]',
        title: "Recto du document",
        message: "Cliquez ou glissez une image/PDF du recto de votre pièce d'identité (carte d'identité, passeport...).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-doc-verso"]',
        title: "Verso du document",
        message: "De même, ajoutez le verso de votre pièce d'identité.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-rgpd-card"]',
        title: "Protection des données",
        message: "Consultez notre politique de protection des données personnelles conforme au RGPD.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-rgpd-checkbox"]',
        title: "Consentement RGPD",
        message: "Cochez cette case pour accepter le traitement de vos données. C'est obligatoire pour utiliser nos services.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="client-infos-save-btn"]',
        title: "Enregistrer",
        message: "Cliquez ici pour sauvegarder toutes vos modifications. Le bouton s'active dès qu'une modification est détectée.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/client/recap-missions",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="recap-missions-card"]',
        title: "Vos missions",
        message: "Cette carte affiche l'historique complet de toutes vos missions avec leur statut actuel.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="recap-missions-header"]',
        title: "Compteur de missions",
        message: "Voyez en un coup d'œil le nombre total de missions et combien sont actuellement affichées après filtrage.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="recap-add-mission-btn"]',
        title: "Nouvelle mission",
        message: "Cliquez ici pour créer une nouvelle demande de mission avec notre assistant IA.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="recap-filters"]',
        title: "Filtres de recherche",
        message: "Utilisez ces filtres pour rechercher une mission par texte ou filtrer par statut (brouillon, en cours, terminée...).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="recap-missions-table"]',
        title: "Tableau des missions",
        message: "Consultez toutes vos missions ici. Cliquez sur une ligne pour voir les détails complets de la mission.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/client/add-mission-ia",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="mission-tabs-list"]',
        title: "Choix du mode de saisie",
        message: "Choisissez entre le mode Vocal (conversation avec l'IA) ou le mode Texte (formulaire classique).",
        position: "bottom"
      },
      {
        target: '[data-onboarding="mission-tab-voice"]',
        title: "Onglet Vocal",
        message: "Cliquez ici pour décrire votre mission en parlant avec notre assistant vocal intelligent.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="mission-tab-text"]',
        title: "Onglet Texte",
        message: "Cliquez ici pour taper votre demande par écrit dans un formulaire.",
        position: "bottom"
      },
      // Steps pour mode vocal
      {
        target: '[data-onboarding="voice-mission-card"]',
        title: "Mode conversationnel",
        message: "Ce bloc vous permet de parler directement avec notre assistant IA pour décrire votre besoin.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="voice-start-button"]',
        title: "Démarrer la conversation",
        message: "Appuyez sur ce bouton pour lancer la conversation vocale avec l'assistant. Il vous guidera pour collecter toutes les informations.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="voice-speed-card"]',
        title: "Vitesse de la voix",
        message: "Ajustez la vitesse de parole de l'assistant selon vos préférences. Votre choix sera mémorisé.",
        position: "bottom"
      },
      // Steps pour mode texte
      {
        target: '[data-onboarding="text-mission-card"]',
        title: "Formulaire de description",
        message: "Décrivez votre besoin ici. L'IA analysera automatiquement votre texte pour extraire les informations clés.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="text-mission-textarea"]',
        title: "Zone de saisie",
        message: "Tapez votre demande en détail : type de travaux, localisation, date souhaitée, contraintes particulières...",
        position: "bottom"
      },
      {
        target: '[data-onboarding="text-mission-mic-btn"]',
        title: "Dictée vocale",
        message: "Maintenez ce bouton enfoncé pour dicter votre texte au lieu de le taper.",
        position: "bottom-left"
      },
      {
        target: '[data-onboarding="text-mission-reanalyze-btn"]',
        title: "Réanalyser",
        message: "Si vous modifiez votre texte, cliquez ici pour relancer l'analyse IA et mettre à jour les informations extraites.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/client/add-mission-texte",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="mission-form"]',
        title: "Formulaire détaillé",
        message: "Remplissez les champs pour décrire précisément votre besoin.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/client/support",
    exactMatch: true,
    tabDataAttribute: "data-support-active-tab",
    steps: (activeTab?: string) => {
      // Steps de base toujours visibles
      const baseSteps: TutorialStep[] = [
        {
          target: '[data-onboarding="support-actions"]',
          title: "Actions rapides",
          message: "Utilisez ces boutons pour actualiser la liste ou créer un nouveau ticket de support.",
          position: "bottom"
        },
        {
          target: '[data-onboarding="support-refresh-btn"]',
          title: "Actualiser",
          message: "Cliquez ici pour rafraîchir la liste de vos tickets.",
          position: "bottom"
        },
        {
          target: '[data-onboarding="support-new-ticket-btn"]',
          title: "Nouveau ticket",
          message: "Cliquez ici pour ouvrir un nouveau ticket de support.",
          position: "bottom-left"
        },
        {
          target: '[data-onboarding="support-tabs-list"]',
          title: "Navigation par onglets",
          message: "Naviguez entre vos tickets existants et la création d'un nouveau ticket.",
          position: "bottom"
        }
      ];

      // Steps pour l'onglet "tickets" (liste)
      if (activeTab === 'tickets' || !activeTab) {
        return [
          ...baseSteps,
          {
            target: '[data-onboarding="support-tab-tickets"]',
            title: "Onglet Mes tickets",
            message: "Vous êtes ici. Consultez la liste de tous vos tickets.",
            position: "bottom"
          },
          {
            target: '[data-onboarding="support-content-tickets"]',
            title: "Liste de vos tickets",
            message: "Visualisez tous vos tickets de support. Cliquez sur une ligne pour voir les détails.",
            position: "bottom"
          }
        ];
      }

      // Steps pour l'onglet "new" (nouveau ticket)
      if (activeTab === 'new') {
        return [
          ...baseSteps,
          {
            target: '[data-onboarding="support-tab-new"]',
            title: "Nouveau ticket",
            message: "Vous êtes ici. Remplissez le formulaire pour soumettre votre demande.",
            position: "bottom"
          },
          {
            target: '[data-onboarding="support-ticket-form"]',
            title: "Formulaire de création",
            message: "Remplissez ce formulaire pour soumettre votre demande de support.",
            position: "bottom"
          }
        ];
      }

      // Steps pour l'onglet "detail" (détail ticket)
      if (activeTab === 'detail') {
        return [
          ...baseSteps,
          {
            target: '[data-onboarding="support-tab-detail"]',
            title: "Détail du ticket",
            message: "Vous consultez les détails d'un ticket.",
            position: "bottom"
          },
          {
            target: '[data-onboarding="support-ticket-detail"]',
            title: "Conversation",
            message: "Consultez l'historique des échanges et répondez directement ici.",
            position: "bottom"
          }
        ];
      }

      return baseSteps;
    }
  }
];
